export default "__VITE_ASSET__CkwXPsJC__"